var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", [
        _c("div", { ref: "container", staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-link btn-l",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$router.go(-1)
                    }
                  }
                },
                [_vm._v("←")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg" },
              [
                _c("progress-bar", {
                  attrs: { options: _vm.options, value: 60 }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4 card" }, [
              _c("img", {
                staticClass: "img",
                attrs: { src: _vm.data.syringesScr.image.url }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix--min" }),
              _vm._v(" "),
              _c("h6", {
                domProps: { innerHTML: _vm._s(_vm.data.syringesScr.header) }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              !_vm.isPhone
                ? _c(
                    "div",
                    {
                      staticClass: "btn-toolbar text-center",
                      attrs: {
                        role: "toolbar",
                        "aria-label": "Toolbar with button groups"
                      }
                    },
                    _vm._l(_vm.data.syringesScr.options, function(opt) {
                      return _c(
                        "div",
                        {
                          key: opt.label,
                          staticClass: "btn-group-toggle",
                          attrs: { role: "group", value: opt.value }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "btn btn-primary btn-lg radio-btn",
                              class: parseInt(opt.value) === 0 ? "no" : "",
                              on: {
                                click: function($event) {
                                  return _vm.toggleActive($event)
                                }
                              }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.screening,
                                    expression: "screening"
                                  }
                                ],
                                attrs: { type: "radio", autocomplete: "off" },
                                domProps: {
                                  value: {
                                    q: _vm.data.syringesScr.header,
                                    value: opt.value
                                  },
                                  checked: _vm._q(_vm.screening, {
                                    q: _vm.data.syringesScr.header,
                                    value: opt.value
                                  })
                                },
                                on: {
                                  change: function($event) {
                                    _vm.screening = {
                                      q: _vm.data.syringesScr.header,
                                      value: opt.value
                                    }
                                  }
                                }
                              }),
                              _vm._v(_vm._s(opt.label) + "\n            ")
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isPhone
                ? _c(
                    "div",
                    _vm._l(_vm.data.syringesScr.options, function(opt) {
                      return _c(
                        "div",
                        {
                          key: opt.label,
                          staticClass: "btn-group-toggle",
                          attrs: { value: opt.value }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "btn btn-primary btn-lg radio-btn",
                              class: parseInt(opt.value) === 0 ? "no" : "",
                              on: {
                                click: function($event) {
                                  return _vm.toggleActive($event)
                                }
                              }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.screening,
                                    expression: "screening"
                                  }
                                ],
                                attrs: { type: "radio", autocomplete: "off" },
                                domProps: {
                                  value: {
                                    q: _vm.data.syringesScr.header,
                                    value: opt.value
                                  },
                                  checked: _vm._q(_vm.screening, {
                                    q: _vm.data.syringesScr.header,
                                    value: opt.value
                                  })
                                },
                                on: {
                                  change: function($event) {
                                    _vm.screening = {
                                      q: _vm.data.syringesScr.header,
                                      value: opt.value
                                    }
                                  }
                                }
                              }),
                              _vm._v(_vm._s(opt.label) + "\n            ")
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" })
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("small", {
                staticClass: "disclaimer",
                domProps: { innerHTML: _vm._s(_vm.data.syringesScr.disclaimer) }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc6b925e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc6b925e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScrNeedle.vue
// module id = null
// module chunks = 